import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0.0110330244L741.970889 984.818788 741.970889 1658.38493 1244.63548 1909.71722 1244.63548 984.818788 1919.9669 88.275228 1831.81304 21.9667515 1134.30524 947.858157 1134.30524 1731.20289 852.301133 1590.20084 852.301133 947.858157 221.322469 110.341277 1483.61079 110.341277 1483.61079 0.0110330244z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconFilterLine = /*#__PURE__*/function (_Component) {
  _inherits(IconFilterLine, _Component);

  var _super = _createSuper(IconFilterLine);

  function IconFilterLine() {
    _classCallCheck(this, IconFilterLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconFilterLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconFilter",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconFilterLine.displayName = "IconFilterLine";
  return IconFilterLine;
}(Component);

IconFilterLine.glyphName = 'filter';
IconFilterLine.variant = 'Line';
IconFilterLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconFilterLine;
export { IconFilterLine };